export const AUDIO_FX = 'AUDIO_FX';
export const MIDI_FX = 'MIDI_FX';
export const LIVE_FX = 'LIVE_FX';
export const OSCILLATOR = 'OSCILLATOR';
